angular.module('MW.CoreStream.ContactManagerTagService', [
    'MW.Influencers.IcmDialogService',
    'MW.Framework.TranslationService',
    'MW.Influencers.AnalyticsService',
    'MW.Framework.CoreUserService',
    'MW.Framework.CoreCompanyService',
    'MW.ContactManager.ContactManagerContactModel'
])
.service('ContactManagerTagService', [
    '$http',
    '$q',
    'CONTACT_MANAGER_MEDIA_LIST_URL',
    'MR_MEDIA_LIST_BFF_URL',
    'ICM_CSS_MEDIA_LIST_URL',
    'CONTACT_MANAGER_CONTACT_URL',
    'DialogService',
    'translationService',
    '$translate',
    'AnalyticsService',
    'CoreUserService',
    'CoreCompanyService',
    'Contact',
    function(
        $http,
        $q,
        CONTACT_MANAGER_MEDIA_LIST_URL,
        MR_MEDIA_LIST_BFF_URL,
        ICM_CSS_MEDIA_LIST_URL,
        CONTACT_MANAGER_CONTACT_URL,
        DialogService,
        translationService,
        $translate,
        AnalyticsService,
        CoreUserService,
        CoreCompanyService,
        Contact
    ) {
        'use strict';
        this.isSaving = false;
        this.isFetching = false;
        this.selectedContactIdForTags = [];
        this.DialogService = DialogService;
        this.translationService = translationService;
        this.$translate = $translate;
        this.Contact = Contact;
        this.selectdLists = [];
        this.mediaListArray = [];
        this.commonMediaList = [];
        this.$q = $q;
        this.AnalyticsService = AnalyticsService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;

        this.updateMediaList = function updateMediaList(mediaListId, mediaListName, mediaListDescription) {
            var payload,
                url = CONTACT_MANAGER_MEDIA_LIST_URL + '/' + mediaListId;

            return this.CoreUserService.getCurrent(true).then((current) => {
                payload = {
                    mediaListName: mediaListName,
                    mediaListDescription: mediaListDescription,
                    lastUpdatedByUserId: current._id,
                    lastUpdatedByFirstName: current.firstName,
                    lastUpdatedByLastName: current.lastName
                };

                return $http.put(url, payload);
            });
        };

        this.saveMediaList = function saveMediaList(tagName) {
            this.isSaving = true;

            return this.CoreUserService.getCurrent(true).then((current) => {
                var payload = {
                    mediaListName: tagName,
                    createdById: current._id,
                    createdByFirstName: current.firstName,
                    createdByLastName: current.lastName
                };
                return new Promise((resolve, reject) => {
                    return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL, payload).then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err.data);
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
                });
            });
        };

        this.getAllTags = function getAllTags(page, size, sort, q) {
            this.isFetching = true;
            var query= {
                    sort: sort,
                    page: page,
                    size: size
                };

            if (q && q.length > 0) {
                query.q = q;
            }

            return new Promise((resolve, reject) => {
                return $http.get(CONTACT_MANAGER_MEDIA_LIST_URL, { params: query }).then((response) => {
                    resolve(response.data);
                }).catch((err) => {
                    reject(err.data);
                })
                .finally(() => {
                    this.isFetching = false;
                });

            });
        };

        this.getMediaListById = function getMediaListById(mediaListId) {
            this.isFetching = true;

            return new Promise((resolve, reject)=>{
                $http.get(CONTACT_MANAGER_MEDIA_LIST_URL + '/' + mediaListId).then( response => {
                    resolve(response.data);
                }).catch(err => {
                    reject(err.data);
                })
                .finally(() => {
                    this.isFetching = false;
                });
            });
        };

        this.saveTagWithContact = function saveTagWithContact(mediaListIds, contactIds) {
            this.isSaving = true;
            var payload;

            return this.CoreUserService.getCurrent(true).then((current) => {
                payload = {
                    contactIds: contactIds,
                    mediaListIds: mediaListIds,
                    lastUpdatedByUserId: current._id,
                    lastUpdatedByFirstName: current.firstName,
                    lastUpdatedByLastName: current.lastName
                };

                return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/addBulkContacts', payload)
                .finally(function afterAll(){
                    this.isSaving = false;
                }.bind(this));
            });
        };

        this.addToMediaListModal = function addToMediaListModal(query, selectedContactIds){
            let manageListDialog = document.querySelector('icm-manage-lists-dialog');

            if(query){
                manageListDialog.openLoading();

                $http(query).then((response) => {
                    manageListDialog.open(response.data);
                }).catch(function(err) {
                    manageListDialog.showLoadingErrorState();
                    reject(err.data); // jshint ignore:line
                });
            }else {
                manageListDialog.open(selectedContactIds);
            }
        };

        this.addToListDialog = function addToListDialog(selectedContacts, callback, criteria, queryType, totalContactsCount) {

            var dialogTitle = this.$translate.instant('icm-medialist__add-to-medialist--dialog-header'),
                dialogTemplate = 'icm-gaf-legacy/views/contact_manager/partials/contact_tag_selector',
                dialogCss = 'mainTagsListDialog',
                _callback = (typeof callback === 'function') ? callback : function() {},
                payload = {
                    selectedContacts: selectedContacts,
                    totalContactsCount: totalContactsCount,
                    listDialogCallback: callback,
                    criteria: criteria || null,
                    queryType: queryType
                };

            this.DialogService.dialog(dialogTitle, dialogTemplate, payload, _callback, undefined, undefined, undefined, dialogCss);
        };

        this.bulkRemoveContactsFromTags = function bulkRemoveContactsFromTags(mediaListIds, contactIds) {
            this.isSaving = true;

            return this.CoreUserService.getCurrent(true).then((current) => {
                var payload = {
                    mediaListIds: mediaListIds,
                    contactIds: contactIds,
                    lastUpdatedByUserId: current._id,
                    lastUpdatedByFirstName: current.firstName,
                    lastUpdatedByLastName: current.lastName
                };

                return new Promise((resolve, reject) => {
                    return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/removeContacts', payload).then(() => {
                        resolve();
                    }).catch((error) => {
                        reject(error.data);
                    }).finally(()=>{
                        this.isSaving = false;
                    });
                });
            });
        };

        this.removeContactsFromTags = function removeContactsFromTags(contactIds){
            this.isSaving = true;
            var defer = $q.defer();
            if(contactIds.length > 0){
                this._trackEvent(contactIds);
                $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/removeBulkContacts', contactIds).then(function(response) {
                    defer.resolve(response.data);
                }).catch(function(err) {
                    defer.reject(err.data);
                })
                .finally(function(){
                    this.isSaving = false;
                }.bind(this));
            } else {
                this.isSaving = false;
                defer.resolve();
            }

            return defer.promise;
        };

        this.removeMediaList = function removeMediaList(mediaListId) {
            var defer = $q.defer();

            if(!mediaListId) {
                defer.reject({message: 'Invalid Medialist'});
                return defer.promise;
            }

            $http.delete(CONTACT_MANAGER_MEDIA_LIST_URL + '/' + mediaListId)
                .then(function(){
                    defer.resolve({message: 'Success'});
                })
                .catch(function() {
                    defer.reject({message: 'Error removing medialist'});
                });

            return defer.promise;
        };

        this.getMediaListEmails = function getMediaListEmails(mediaListId, pageSize) {
            this.isFetching = true;
            var defer = $q.defer(),
                payload = {
                    mediaListIds: [mediaListId],
                    pageSize: pageSize
                };

            $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/mediaList', payload).then(function(response) {
                defer.resolve(response.data);
            }).catch(function(err) {
                defer.reject(err.data);
            })
            .finally(function afterAll(){
                this.isFetching = false;
            }.bind(this));

            return defer.promise;
        };


        this.setSelectedMedialist = function setSelectedMedialist(selectdListObj) {
            this.selectdLists = selectdListObj;
        };

        this.getSelectedMedialist = function getSelectedMedialist() {
            return this.selectdLists;
        };

        this.set = function set(tagsArr, commonMediaList) {
            this.mediaListArray = tagsArr;
            this.commonMediaList = commonMediaList;
        };

        this.getTagsArr = function getTagsArr() {
           return this.mediaListArray;
        };

        this.getCommonMediaList = function getCommonMediaList() {
            return this.commonMediaList;
        };

        this.updateContactMediaLists = function updateContactMediaLists(contactArray, contactIds, selectedMediaLists, listsToRemove, selectedMediaListSnippets){
            contactArray.forEach(function mapContacts(contact){
                if(contactIds.indexOf(contact.id) !== -1){
                    if(selectedMediaListSnippets && (selectedMediaListSnippets.length > 0)) {
                        selectedMediaListSnippets.forEach(function(mediaListSnippet) {
                            var duplicateList = false;
                            contact.mediaLists.some(function(mediaList) {
                                if(mediaList.key === mediaListSnippet.key) {
                                    duplicateList = true;
                                    return true;
                                }
                            });

                            if(!duplicateList) {
                                contact.mediaLists.push(mediaListSnippet);
                            }
                        });
                    } else {
                        selectedMediaLists.forEach(function(listId){
                            if(contact.mediaLists.indexOf(listId) === -1){
                                contact.mediaLists.push(listId);
                            }
                        });
                    }

                    // TODO: This block needs to be cleaned up when all selectAll media list stories are done since listsToRemove should be removed.
                    if(listsToRemove && Array.isArray(listsToRemove)) {
                        listsToRemove.forEach(function(listId){
                            var index = contact.mediaLists.indexOf(listId);

                            if(index !== -1){
                                contact.mediaLists.splice(index, 1);
                            }
                        });
                    }
                }
            });
        };

        this.updateContactMediaListsWithQuery = function updateContactMediaListsWithQuery(documentQuery, selectedMediaLists, queryType){
            this.isSaving = true;

            return this.CoreUserService.getCurrent(true).then((current) => {
                var payload = {
                    query: documentQuery,
                    mediaLists: selectedMediaLists,
                    lastUpdatedByUserId: current._id,
                    lastUpdatedByFirstName: current.firstName,
                    lastUpdatedByLastName: current.lastName
                };
                if (queryType === 'searchContact' || queryType === 'searchRelevantContact') {
                    return $http.post(ICM_CSS_MEDIA_LIST_URL + '/addByQuery/' + queryType, payload).finally(() => {
                        this.isSaving = false;
                    });
                }
                else {
                    return $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/addByQuery/' + queryType, payload).finally(() => {
                        this.isSaving = false;
                    });
                }
            });
        };

        this.updatePreselectedContactsMediaLists = function updatePreselectedContactsMediaLists(preSelectedContacts, selectedMediaListIds) {
            var contactIdArray = Object.keys(preSelectedContacts),
                defer = $q.defer();

            for (var i=0; i<contactIdArray.length; i++) {
                preSelectedContacts[contactIdArray[i]].mediaLists = [];
                for(var j=0; j<selectedMediaListIds.length; j++) {
                    if(preSelectedContacts[contactIdArray[i]].mediaLists.indexOf(selectedMediaListIds[j]) === -1) {
                         preSelectedContacts[contactIdArray[i]].mediaLists.push(selectedMediaListIds[j]);
                    }
                }
            }
            defer.resolve(preSelectedContacts);
            return defer.promise;
        };

        this.getAllContacts = function getAllContacts(query){
            var defer = $q.defer();

            $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/getAllContacts', query).then(function(response) {
                if(response.data && response.data.hits){
                    response.data.hits = response.data.hits.map(function (hit) {
                        return new Contact(hit, response.data.sources);
                    }.bind(this));

                    defer.resolve(response.data);
                } else {
                    defer.resolve({data: {hits: []}});
                }

            }).catch(function(err) {
                defer.reject(err.data);
            });

            return defer.promise;
        };

        this.getContactsByMediaListIds = function getContactsByMediaListIds(query){
            var defer = $q.defer();

            $http.post(CONTACT_MANAGER_MEDIA_LIST_URL + '/getContactsByMediaListIds', query).then(function(response) {
                if(response.data && response.data.hits){
                    response.data.hits = response.data.hits.map(function (hit) {
                        return new Contact(hit, response.data.sources);
                    }.bind(this));

                    defer.resolve(response.data);
                } else {
                    defer.resolve({data: {hits: []}});
                }

            }).catch(function(err) {
                defer.reject(err.data);
            });

            return defer.promise;
        };

        this.getEntriesByMediaListIds = function getEntriesByMediaListIds(mediaListId, query){
            var defer = $q.defer();

            $http.post(MR_MEDIA_LIST_BFF_URL + '/media-lists/entries/' + mediaListId, query).then(function(response) {
                if(response.data){
                    defer.resolve(response.data);
                } else {
                    defer.resolve({data: []});
                }

            }).catch(function(err) {
                defer.reject(err.data);
            });

            return defer.promise;
        };

        this.getAllMediaListsForContactId = function getAllMediaListsForContactId(contactId){
            var defer = $q.defer();
            $http.get(CONTACT_MANAGER_CONTACT_URL + '/medialists/' + contactId)
                .then(function(data){
                    if(!angular.isArray(data.data)){
                        data.data = [];
                    }
                    defer.resolve(data.data);
                })
                .catch(function(err){
                    defer.reject(err);
                });
            return defer.promise;
        };

        this.addToComposeMediaListsDialog = function addToComposeMediaListsDialog(allMediaLists, preSelectedMediaLists, recipientsLabel, callback) {
            var dialogTitle = this.translationService.getLocalizedString('Recipients'),
                dialogTemplate = 'icm-web/views/partials/compose_medialists_selector',
                dialogCss = 'composeMedialistDialog',
                _callback = (typeof callback === 'function') ? callback : function() {},
                payload = {
                    wrapperTemplate: 'icm-gaf-legacy/views/partials/dialog_manager_content_scroll',
                    allMediaLists: allMediaLists,
                    preSelectedMediaLists: preSelectedMediaLists,
                    recipientsLabel: recipientsLabel,
                    listDialogCallback: callback
                };
            this.DialogService.dialog(dialogTitle, dialogTemplate, payload, _callback, undefined, undefined, undefined, dialogCss);
        };

        this._trackEvent = function _trackEvent(tagsArr) {
            var promises = [],
                currentUser,
                currentCompany,
                currentMediaListId = '',
                trackingData;

            promises.push(this.CoreUserService.getCurrent(true));
            promises.push(this.CoreCompanyService.getCurrent(true));

            this.$q.all(promises).then(function(responses) {
                currentUser = responses[0];
                currentCompany = responses[1];
                trackingData = {
                    source: 'webapp',
                    label: 'remove_contact',
                    contactCount: tagsArr.length,
                    parentType: 'ICM_contacts_list',
                    userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
                };
                tagsArr.forEach(function(list) {
                    if (list.mediaListId !== currentMediaListId) {
                        trackingData.mediaListId = list.mediaListId;
                        this.AnalyticsService.trackMediaListOperation('remove_contact', trackingData);
                        currentMediaListId = list.mediaListId;
                    }
                }.bind(this));

            }.bind(this));
        };
    }
]);
